
export const listStyle = {
  name: 'list-style'
}

export const listStyleType = {
  name: 'list-style-type'
}

export const listStyleImage = {
  name: 'list-style-image'
}

export const listStylePosition = {
  name: 'list-style-position'
}